import React from 'react';
import { MdDashboard, MdCategory } from "react-icons/md";
import { FaBlog } from "react-icons/fa";
import { GrServices } from "react-icons/gr";
import { IoLogOut } from "react-icons/io5";
import { IoIosContact } from "react-icons/io";
import { GrTransaction } from "react-icons/gr";
import { MdWorkOutline } from "react-icons/md";
import { FaBuilding } from "react-icons/fa";
import { MdWork } from "react-icons/md";
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useCart } from '../context/cartContext';

const Sidebar = ({ showSidebar, toggleSidebar }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useCart();

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    localStorage.removeItem('token');
    toast.success("Logout successful");
    navigate("/adminLogin");
  };

  const labelToModuleMap = {
    "Dashboard Access": "Dashboard Access",
    "Sub Admin List": "SubAdmin",
    "Blog Management": "Blog Management",
    "Category Management": "Category Management",
    "Service Management": "Service Page",
    "Contact List": "Contact Forms",
    "Transaction List": "Transaction",
    "Logout": "Logout",
    "Job": "Job"
  };

  const allowedModules = user?.userType === "SubAdmin"
    ? user?.permissions?.filter(p => p.isAllow).map(p => p.moduleName)
    : null;

  const isModuleAllowed = (label) => {
    if (user?.userType !== "SubAdmin") return true;
    const module = labelToModuleMap[label];
    // console.log(labelToModuleMap)
    // console.log(allowedModules?.includes(module),label )
    return allowedModules?.includes(module);
  };

  const routes = [
    {
      section: "Menu",
      items: [
        { path: "/admin/dashboard", label: "Dashboard", icon: <MdDashboard size={20} /> },
        { path: "/admin/list-subadmin", label: "Sub Admin List", icon: <MdDashboard size={20} /> },
      ],
    },
    {
      section: "Blog",
      items: [
        { path: "/admin/blog-list", label: "Blog Management", icon: <FaBlog size={20} /> },
        { path: "/admin/category-list", label: "Category Management", icon: <MdCategory size={20} /> },
      ],
    },
    {
      section: "Pages",
      items: [
        { path: "/admin/list-services", label: "Service Management", icon: <GrServices size={20} /> },
        { path: "/admin/list-static-content", label: "Static Pages", icon: <GrServices size={20} /> },
      ],
    },
    {
      section: "Components",
      items: [
        {
          path: "/admin/contact-list",
          label: "Contact List",
          icon: <IoIosContact fontSize={"20px"} />
        },
        {
          path: "/admin/career-list",
          label: "Career List",
          icon: <MdWork fontSize={"20px"} />
        },
        {
          path: "/admin/transaction-list",
          label: "Transaction List",
          icon: <GrTransaction fontSize={"20px"} />
        },
        {
          path: "/admin/job-list",
          label: "Job List",
          icon: <MdWorkOutline fontSize={"20px"} />
        },
        {
          path: "/admin/department-list",
          label: "Department List",
          icon: <FaBuilding fontSize={"20px"} />
        },
        { path: null, label: "Logout", icon: <IoLogOut fontSize={"20px"} />, onClick: handleLogout },
      ],
    },
  ];

  return (
    <>


      <div className={`sidebarContainer ${showSidebar ? 'show' : ''}`}>
        <div className="logoWrapper">
          <img src="/logo-light.png" alt="Logo" className="logoImage" />
          <button className="closeSidebarBtn" onClick={toggleSidebar}>×</button>
        </div>

        {routes.map((section, index) => {
          const visibleItems = section.items.filter(item =>
            item.label === "Logout" || isModuleAllowed(item.label === "Dashboard" ? "Dashboard Access" : (item.label === "Job List" || item.label === "Department List") ? "Job" : item.label)
          );

          if (visibleItems.length === 0) return null;

          return (
            <div key={index}>
              <div className="sectionTitle">{section.section}</div>
              {visibleItems.map((item, i) => (
                <div
                  key={i}
                  className={`menuItem ${item.path && isActive(item.path) ? 'activeItem' : ''}`}
                  onClick={() => {
                    if (item.path) {
                      navigate(item.path);
                      toggleSidebar();
                    } else if (item.onClick) {
                      item.onClick();
                      toggleSidebar();
                    }
                  }}
                >
                  <span className="iconWrapper">{item.icon}</span> {item.label}
                </div>
              ))}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default Sidebar;
